import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import {
  ListTagsAndGroupsQuery,
  ListTagsAndGroupsQueryVariables,
} from "~frontend/__generated__/graphql";
import { LIST_TAGS_AND_GROUPS } from "~frontend/graphql/tags";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";
import formatTagName from "~frontend/util/formatTagName";

export default function useTagName(): {
  getTagName: (tagId: string) => string | null;
  state: "loading" | "error" | "ready";
} {
  const { subaccount } = useSubaccount()!;

  const tagsAndGroups = useQuery<
    ListTagsAndGroupsQuery,
    ListTagsAndGroupsQueryVariables
  >(LIST_TAGS_AND_GROUPS, {
    variables: {
      subaccountId: subaccount.id,
    },
  });

  const nameById = useMemo(() => {
    const map: { [key: string]: string } = {};
    if (tagsAndGroups.data) {
      tagsAndGroups.data.listTags.forEach(tag => {
        map[tag.id] = tag.name;
      });
      tagsAndGroups.data.listTagGroups.forEach(group => {
        group.tags.forEach(tag => {
          map[tag.id] = formatTagName({
            name: tag.name,
            group,
          });
        });
      });
    }
    return map;
  }, [tagsAndGroups.data]);

  return {
    getTagName: (tagId: string) => {
      return nameById[tagId] || null;
    },
    state: tagsAndGroups.loading
      ? "loading"
      : tagsAndGroups.error
        ? "error"
        : "ready",
  };
}
